import { render } from "./FormItemCard.vue?vue&type=template&id=4a3d3478&scoped=true&ts=true"
import script from "./FormItemCard.vue?vue&type=script&lang=ts"
export * from "./FormItemCard.vue?vue&type=script&lang=ts"

import "./FormItemCard.vue?vue&type=style&index=0&id=4a3d3478&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3d3478"]])

export default __exports__